module.exports = __webpack_public_path__ + "img/freight_yard4_2.b3e3b462.png";